import { Body, Box, Container, Heading } from '@hover/blueprint';
import React, { useState } from 'react';
import IntersectBox from '../../common/intersect-box';
import { OUR_TOOLS } from '../../../constants';
import { ICareersOurTool } from '../../../interfaces/ICareersOurTool';

const CareersOurToolsDesktop: React.FC = () => {
  const [sectionOneImageIntersect, setSectionOneIntersect] =
    useState<number>(0);
  const [sectionTwoImageIntersect, setSectionTwoIntersect] =
    useState<number>(0);
  const [sectionThreeImageIntersect, setSectionThreeIntersect] =
    useState<number>(0);

  return (
    <Box d={{ base: 'none', desktop: 'flex' }}>
      <Box
        ml="110px"
        w="100%"
        position="sticky"
        top={0}
        d="flex"
        alignItems="center"
        justifyContent="center"
        h="100vh"
      >
        <Box maxW="450px">
          {OUR_TOOLS.map((tool: ICareersOurTool) => {
            let width: string | number = 0;
            let opacity = 0;
            if (tool.id === 0) {
              width = sectionOneImageIntersect >= 0.3 ? 'auto' : 0;
              opacity = sectionOneImageIntersect;
            }
            if (tool.id === 1) {
              width =
                sectionTwoImageIntersect >= 0.3 &&
                sectionOneImageIntersect < 0.3
                  ? 'auto'
                  : 0;
              opacity = sectionTwoImageIntersect;
            }
            if (tool.id === 2) {
              width =
                sectionThreeImageIntersect >= 0.3 &&
                sectionTwoImageIntersect < 0.3
                  ? 'auto'
                  : 0;
              opacity = sectionThreeImageIntersect;
            }
            return (
              <React.Fragment key={tool.id}>
                <Box opacity={opacity} w={width}>
                  {tool.image}
                </Box>
              </React.Fragment>
            );
          })}
        </Box>
      </Box>
      <Box w="100%" height="300vh" flexDir="column">
        {OUR_TOOLS.map((tool: ICareersOurTool) => (
          <React.Fragment key={tool.id}>
            <IntersectBox
              setSectionIntersect={entry => {
                if (tool.id === 0) {
                  setSectionOneIntersect(entry);
                }
                if (tool.id === 1) {
                  setSectionTwoIntersect(entry);
                }
                if (tool.id === 2) {
                  setSectionThreeIntersect(entry);
                }
              }}
            >
              <Box
                pl={700}
                h="100vh"
                flexDir="column"
                alignItems="flex-start"
                justifyContent="center"
              >
                <Heading marginBottom={200} size={600} isLight as="h2">
                  {tool.title}
                </Heading>
                <Container px={200}>
                  <Body size={500} marginBottom={200}>
                    {tool.body}
                  </Body>
                </Container>
              </Box>
            </IntersectBox>
          </React.Fragment>
        ))}
      </Box>
    </Box>
  );
};

export default CareersOurToolsDesktop;
